import PropTypes from 'prop-types';

const serviceOpeningTimesShape = {
  dayOfWeek: PropTypes.string.isRequired,
  opens: PropTypes.string,
  closes: PropTypes.string,
  validFrom: PropTypes.string,
  validTo: PropTypes.string,
  comment: PropTypes.string,
};


export {serviceOpeningTimesShape};



// WEBPACK FOOTER //
// ./src/domain/serviceOpeningTimes.js